import Vue from 'vue'
import VideoPlayer from './video-player/index.vue'
 
Vue.component('a-video-player', VideoPlayer)